// src/PublishSuccess.js
// Подтверждение публикации: галочка и место, куда пост попал.

import React, { useEffect } from 'react';
import './PublishSuccess.css';

export default function PublishSuccess({ title, sectionTitle, subcategoryTitle, onClose }) {
  // Окно закрывается только по кнопке «Готово»: само по времени не исчезает
  // и не закрывается кликом мимо, чтобы сообщение нельзя было пропустить.
  // Escape оставлен как клавиатурный эквивалент кнопки.
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  return (
    <div className="publish-success" role="status" aria-live="polite">
      <div className="publish-success-card">
        <div className="publish-success-mark">
          <svg viewBox="0 0 52 52" aria-hidden="true">
            <circle className="publish-success-circle" cx="26" cy="26" r="23" />
            <path className="publish-success-check" d="M15 27.5l7.5 7.5L37.5 19" />
          </svg>
        </div>

        <h3 className="publish-success-title">Пост опубликован</h3>
        {title && <p className="publish-success-post">«{title}»</p>}

        <div className="publish-success-place">
          <span className="publish-success-chip">
            {sectionTitle || 'Без раздела'}
          </span>
          {subcategoryTitle && (
            <>
              <span className="publish-success-arrow" aria-hidden="true">→</span>
              <span className="publish-success-chip subcategory">{subcategoryTitle}</span>
            </>
          )}
        </div>

        <button type="button" className="publish-success-button" onClick={onClose}>
          Готово
        </button>
      </div>
    </div>
  );
}
